class ConditionalPrivacyContentHandler {
	constructor() {
		this.init();
	}

	init() {
		const scripts = document.querySelectorAll<HTMLScriptElement>('script[type="conditionalPrivacyContent"]');
		scripts.forEach((script) => {
			if (this.shouldLoadContent()) {
				this.loadContent(script);
			} else {
				this.showPlaceholder(script);
			}
		});
	}

	shouldLoadContent(): boolean {
		const allowCookies = document.documentElement.classList.contains('allowCookies');
		const dntEnabled =
			navigator.doNotTrack === '1' ||
			window.doNotTrack === '1';
			//navigator.msDoNotTrack === '1';
		return allowCookies && !dntEnabled;
	}

	loadContent(script: HTMLScriptElement): void {
		const content = script.innerHTML;
		const fragment = document.createRange().createContextualFragment(content);
		script.parentNode?.replaceChild(fragment, script);
	}

	showPlaceholder(script: HTMLScriptElement): void {
		const placeholder = this.createPlaceholder(script);
		script.parentNode?.insertBefore(placeholder, script);

		const button = placeholder.querySelector<HTMLButtonElement>('button');
		if (button) {
			button.addEventListener('click', () => {
				this.loadContent(script);
				placeholder.remove();
			});
		}
	}

	createPlaceholder(script: HTMLScriptElement): HTMLElement {
		const div = document.createElement('div');
		div.className = 'conditionalPrivacyContent';

		const { domain, providerName } = this.getProviderInfo(script);

		const message = document.createElement('p');
		message.textContent = `This embedded content is loaded from ${domain} but is blocked because you have not accepted the necessary cookies or have Do Not Track (DNT) enabled in your browser. Click the button below to load the content from ${providerName} and allow any tracking or cookie use the embed provider uses.`;

		const button = document.createElement('button');
		const span = button.appendChild(document.createElement('span'));
		button.classList.add('btn');
		span.textContent = `Load Content From ${providerName}`;

		div.appendChild(message);
		div.appendChild(button);

		return div;
	}

	getProviderInfo(script: HTMLScriptElement): { domain: string, providerName: string } {
		const content = script.innerHTML;
		const parser = new DOMParser();
		const doc = parser.parseFromString(content, 'text/html');

		const iframe = doc.querySelector('iframe');
		if (iframe) {
			const src = iframe.getAttribute('src');
			if (src) {
				try {
					const url = new URL(src, window.location.origin);
					const domain = url.hostname;
					const providerName = this.getProviderName(domain);
					return { domain, providerName };
				} catch (e) {
					// Invalid URL
				}
			}
		}
		return { domain: 'a third-party', providerName: 'a third-party' };
	}

	getProviderName(domain: string): string {
		const mappings: { [key: string]: string } = {
			'youtube.com': 'YouTube',
			'vimeo.com': 'Vimeo',
			'x.com': 'X',
		};

		for (const key in mappings) {
			//if (domain.includes(key)) {
			if (domain.indexOf(key) !== -1) {
				return mappings[key];
			}
		}
		return 'a third-party';
	}
}

// Instantiate the handler to activate the functionality
new ConditionalPrivacyContentHandler();